import { render } from "./SettingsTaxPage.vue?vue&type=template&id=669029f2"
import script from "./SettingsTaxPage.vue?vue&type=script&lang=js"
export * from "./SettingsTaxPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__